<template>
  <div>
    <v-dialog fullscreen v-model="dialog">

      <v-overlay :value="isLoading"
                 color="white"
                 opacity="0.5">
        <v-progress-circular
            color="primary"
            indeterminate
            size="50"
        ></v-progress-circular>
      </v-overlay>

      <v-card>
        <v-card-title>
          Affecter les utilisateurs
          <v-spacer/>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-8">

          <v-row justify="center">
            <v-col cols="8">
              <v-autocomplete :items="databases"
                              v-model="database_ids"
                              multiple
                              chips
                              small-chips
                              deletable-chips
                              clearable
                              counter
                              prepend-icon="mdi-filter"
                              label="Filtrer par une base de données"
                              outlined
                              item-text="name"
                              item-value="id"></v-autocomplete>
            </v-col>
          </v-row>

          <div class="text-center">
            <v-btn color="gifty"
                   :disabled="!database_ids.length"
                   @click="getUsers"
                   depressed
                   class="rounded-lg white--text">
              <v-icon left>mdi-magnify</v-icon>
              Recherche
            </v-btn>
          </div>

          <div>
            <v-text-field :style="{width : '350px'}"
                          v-model="keyword"
                          append-icon="mdi-magnify"
                          clearable
                          dense
                          class="mt-10"
                          filled
                          placeholder="Rechercher..."
                          rounded

            />

            <div v-if="users.length">
              <v-progress-linear v-if="searchLoading" color="gifty" indeterminate rounded/>
              <v-simple-table class="table-border rounded-lg">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>
                      <v-icon @click="toggleSelectAll"
                              color="success"
                              v-if="allSelected">
                        mdi-checkbox-marked
                      </v-icon>

                      <v-icon @click="toggleSelectAll"
                              v-else>
                        mdi-checkbox-blank-outline
                      </v-icon>
                    </th>
                    <th>Nom</th>
                    <th>Téléphone</th>
                    <th>Email</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(user ,index) in users" :key="index">
                    <td>

                      <v-icon @click="toggleUserSelection(user.id)"
                              color="success"
                              v-if="isSelected(user.id)">
                        mdi-checkbox-marked
                      </v-icon>

                      <v-icon @click="toggleUserSelection(user.id)"
                              v-else>
                        mdi-checkbox-blank-outline
                      </v-icon>

                    </td>
                    <td>{{ user.name }}</td>
                    <td>{{ user.phone }}</td>
                    <td>{{ user.email }}</td>
                  </tr>
                  </tbody>
                       <tr>
                    <th>
                      <v-icon @click="toggleSelectAll"
                              color="success"
                              v-if="allSelected">
                        mdi-checkbox-marked
                      </v-icon>

                      <v-icon @click="toggleSelectAll"
                              v-else>
                        mdi-checkbox-blank-outline
                      </v-icon>
                    </th>
                    <th>Nom</th>
                    <th>Téléphone</th>
                    <th>Email</th>
                  </tr>
                </template>
              </v-simple-table>
            </div>

            <div v-else>
              <v-row align="center" justify="center">
                <v-col cols="7">
                  <v-alert type="info" text class="my-10">
                    Aucun point de vente affiché ! Veuillez utiliser le filtre ci-dessous.
                  </v-alert>
                </v-col>
              </v-row>
            </div>
          </div>

          <v-card-actions>

            <div :style="{width: '120px'}">
              <v-select v-model="limit"
                        :items="[10,20,30,50,100,200,300,400,500,1000,1500,2000]"
                        dense
                        hide-details
                        label="Ligne par page"
                        outlined></v-select>
            </div>

            <v-spacer/>

            <v-pagination v-model="pagination.current"
                          :length="pagination.total"
                          circle
                          total-visible="8"
                          @input="getUsers"></v-pagination>

          </v-card-actions>

        </v-card-text>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  props: ['campaign'],
  data() {
    return {
      dialog: false,
      searchLoading: false,
      isLoading: false,
      investigationIndex: 0,
      databases: [],

      keyword: null,
      database_ids: [],
      users: [],
      total: 0,
      limit: 10,
      pagination: {
        current: 1,
        total: 0
      },
    }
  },

  methods: {
    isSelected(userId) {
      return this.campaign.investigations[this.investigationIndex].user_ids.includes(userId)
    },
    open(investigationIndex) {
      if (!this.databases.length) {
        this.getDatabases()
      }
      this.dialog = true
      this.investigationIndex = investigationIndex
      this.getUsers()
    },
    getDatabases() {
      this.isLoading = true
      HTTP.get('/v1/opus/campaigns/databases').then((res) => {
        this.databases = res.data.data
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    getUsers(isLoading = true) {
      if (isLoading) {
        this.isLoading = true
      } else {
        this.searchLoading = true
      }
      HTTP.get('/v1/opus/campaigns/users?page=' + this.pagination.current, {
        params: {
          keyword: this.keyword,
          limit: this.limit,
          database_ids: this.database_ids,
        }
      }).then(res => {
        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;
        this.users = res.data.data.data
        this.isLoading = false
        this.searchLoading = false
      }).catch(err => {
        this.isLoading = false
        this.searchLoading = false
        console.log(err)
      })
    },
    toggleUserSelection(userId) {
      const ids = this.campaign.investigations[this.investigationIndex].user_ids;
      const index = ids.indexOf(userId);

      if (index === -1) {
        ids.push(userId);
      } else {
        ids.splice(index, 1);
      }
    },
    toggleSelectAll() {
      const ids = this.users.map((user) => user.id);
      const selectedIds = this.campaign.investigations[this.investigationIndex].user_ids;

      if (this.allSelected) {
        this.campaign.investigations[this.investigationIndex].user_ids = selectedIds.filter(
            (id) => !ids.includes(id)
        );
      } else {
        this.campaign.investigations[this.investigationIndex].user_ids = [...new Set([...selectedIds, ...ids])];
      }
    },
  },
  computed: {
    allSelected() {
      const selectedIds = this.campaign.investigations[this.investigationIndex].user_ids;
      return this.users.every((user) => selectedIds.includes(user.id));
    },
  },
  watch: {
    limit() {
      this.pagination.current = 1
      this.getUsers();
    },
    keyword() {
      this.getUsers(false);
    },
  }
}
</script>

<style scoped>
.bg-subtle-gifty {
  background-color: rgba(214, 12, 86, 0.15) !important;
}
</style>